import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Autocomplete,
} from "@mui/material";
import { useState, useEffect } from "react";
import { createPost, Post } from "../api/posts";
import { getTopics } from "../api/topics";

type Props = {
  open: boolean;
  onClose: () => void;
  onCreated: (post?: Post) => void;
  defaultTopic?: string;
};



export default function CreatePostDialog({ open, onClose, onCreated, defaultTopic }: Props) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [topicName, setTopicName] = useState<string>("General");
  const [suggestions, setSuggestions] = useState<string[]>([]);

  useEffect(() => {
    if (open) {
      if (defaultTopic) {
        setTopicName(defaultTopic);
      }
      getTopics().then(topics => {
        setSuggestions(topics.map(t => t.name));
      }).catch(() => {});
    }
  }, [open, defaultTopic]);

  async function submit() {
    if(!title || !content || !topicName) return; 
    const newPost = await createPost(title, content, topicName);
    setTitle("");
    setContent("");
    setTopicName("General");
    onCreated(newPost);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle fontWeight={700}>Create Post</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            variant="outlined"
          />

          <Autocomplete
            freeSolo
            options={suggestions}
            value={topicName}
            onInputChange={(_, newValue) => setTopicName(newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Topic" variant="outlined" />
            )}
          />

          <TextField
            label="Content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button variant="contained" onClick={submit} disabled={!title || !content} disableElevation>
          Post
        </Button>
      </DialogActions>
    </Dialog>
  );
}
